<template>
  <div>
    <VehicleInfo></VehicleInfo>
    <div class="smaller-container-wrapper full-height with-vehicle-desc">
      <h2 class="pt-5" data-cy="pageHeading">{{ $t('message.eCommerceV2.selectFlow.heading') }}</h2>
      <div class="mt-4">
        <div v-for="(option, index) in filteredFlowOptions" :key="index">
          <MobialisSelectionRadioWithValidation
            class="eComV2SelectFlow"
            error=""
            v-model="localFlowSelected"
            name="payment-method"
            :options="[option]"
            :data-cy="option.value"
          >
          </MobialisSelectionRadioWithValidation>
        </div>
      </div>
      <p class="text-danger small my-0" v-if="!isValid">{{ $t('message.eCommerceV2.pleaseSelect') }}</p>
      <div class="push-down-desktop">
        <mobialis-button
          type="submit"
          class="mt-5 mb-3"
          @click="next()"
          data-cy="continue"
          v-av-analytics-cta-interaction="{
            elementText: $t('message.common.continue'),
            eventActionResult: localFlowSelected === null ? 'error' : 'open',
          }"
          >{{ $t('message.common.continue') }}</mobialis-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapState } from 'vuex';
import VehicleInfo from '@/components/VehicleInfo.vue';

export default {
  name: 'ECommerceSelectFlow',
  components: {
    VehicleInfo,
  },
  data() {
    return {
      localFlowSelected: cloneDeep(this.$store.state.ecommerceV2.flowSelected),
      isValid: true,
    };
  },
  computed: {
    ...mapState({
      hideExploreCalculatorButton: state => state.business.info.ecomV2Settings.showExploreCalculatorButton === false,
      paymentSummaryData: state => state.paymentCalculator.paymentSummaryData,
    }),
    flowOptions() {
      return this.$t('message.eCommerceV2.selectFlow.flowOptions');
    },
    filteredFlowOptions() {
      return this.hideExploreCalculatorButton
        ? this.flowOptions.filter(option => option.value !== 'explore-calculator')
        : this.flowOptions;
    },
  },
  async created() {
    await this.getPaymentsData();
  },
  methods: {
    async getPaymentsData() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('paymentCalculator/getPaymentCalculatorSettings', {
          isEcomV2: true,
          vehiclePrice: this.$route.query.purchasePrice,
        });
        // If we don't have lease or finance data then skip the flows and go to
        // the payment calculator, will happen on some older vehicles.
        // If hideExploreCalculatorButton is true + we have finance data,
        // we only will only show personalized payment so just route to that flow.
        if (this.paymentSummaryData) {
          if (!this.paymentSummaryData.lease && !this.paymentSummaryData.finance) {
            this.$router.push('explore-calculator/payment-calculator');
          } else if (this.hideExploreCalculatorButton) {
            this.$router.push('personalized-payment/step-one');
          }
        }
      } catch (error) {
        this.$log('Error in ecomv2 getPaymentCalculatorSettings', error);
        this.$router.push('error');
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
    next() {
      if (!this.localFlowSelected) {
        this.isValid = false;
        return;
      }
      this.isValid = true;
      this.$store.commit('ecommerceV2/SET_STATE', ['flowSelected', this.localFlowSelected]);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss">
.eComV2SelectFlow span.p {
  max-width: 440px;
}
</style>
